
import { Sale } from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleRequiremenets } from "@/utils/sale-layouts/requirements";
import AppLogo from "@/components/layout-editor/Logo.vue";
import Vue from "vue";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { ILayoutImage } from "@/utils/layout-editor";
import AppFreeBlock from "./FreeBlock.vue";
import { FreeBlock } from "@/utils/documents/free-block";

export default Vue.extend({
	props: {
		lang: String,
		exampleDocument: Object as () => Sale,
		layout: {
			type: Object as ()=> SaleLayout,
			required: true
		}
	},
	computed: {
		requirements():SaleRequiremenets{
			return this.layout.Requirements;
		},
		logos():ILayoutImage[] {
			return this.layout.getLogosByPlacement("Requirements");
		},
		freeBlocks():FreeBlock[] {
			return this.layout.getFreeBlocksByPlacement("Requirements");
		},
		exampleText():string{
			if (this.exampleDocument != null) {
				return DossierConfigService.getSaleConfig(this.exampleDocument.TypeID).Requirements.getTranslation(this.lang);
			}
			return DossierConfigService.getSaleConfig(1).Requirements.getTranslation(this.lang);
		},
	},
	components: {
		AppLogo,
		AppFreeBlock
	}
});
